import React from "react";

import ServiceCardButton from "../ServiceCardButtons";

const ServiceCard = ({ title, description, imageDesktop, imageMobile }) => {
  return (
    <div className="w-full md:h-[460px]  bg-[#E6E7F8] md:py-[32px] md:pl-[60px] md:pr-[0]  mb-[24px] px-4 py-6">
      {/* Mobile Card */}
      <div className=" lg:hidden">
        {/* Mobile Image */}
        <div className="w-full flex justify-center ">
          <div className="w-full mb-[24px] max-w-[310px] h-[175px] rounded-[500px]  overflow-hidden">
            <img
              src={imageMobile || imageDesktop}
              alt={title}
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Mobile Text */}
        <div className="">
          <h2
            className="text-[#2C3075] mb-[22px] font-generalsans-subheading  leading-[110%]  text-left  "
            style={{ fontSize: "32px" }}
          >
            {title}
          </h2>
          <div className="w-full h-[1px] bg-[#2C3075]" />
          <p className="text-[#2C3075] font-generalsans-description my-4">
            {description}
          </p>

          <ServiceCardButton label="Book an appointment" to="/contact" />
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden lg:grid grid-cols-12 gap-5 bg-[#E6E7F8]   overflow-hidden  items-center">
        {/* Left Column: Text */}
        <div className="col-span-7 w-[615px] flex flex-col justify-center">
          <h2 className="text-[#2C3075] font-generalsans-subheading  md:text-[48px] mb-[24px]">
            {title}
          </h2>
          <div className="w-[615px] h-[1px] bg-[#2C3075] " />
          <p className="text-[#2C3075] font-generalsans-description my-4 max-w-[90%]">
            {description}
          </p>

          <div className="w-[260px]">
            <ServiceCardButton label="Book an appointment" to="/contact" />
          </div>
        </div>

        {/* Right Column: Image (touches right edge now) */}
        <div className="col-span-5">
          <div className="w-[600px] h-[390px] rounded-l-[500px] rounded-r-none overflow-hidden">
            <img
              src={imageDesktop}
              alt={title}
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
